<template>
    <div>

        <listing-loading v-if="isIdefixStatusAndIdefixStatusDevEmpty && !timeout" text="Loading..."></listing-loading>

        <v-fade-transition>

            <v-row v-if="isIdefixStatusAndIdefixStatusDevEmpty && timeout" class="h-60-vh align-center text-center">
                <v-col class="body-2">

                    <v-icon class="mr-2" v-text="icons.mdiAlertCircle"></v-icon>

                    {{ $gettext('An error occurred while loading the information') }}

                </v-col>
            </v-row>

            <v-row v-if="idefixStatusIsNotEmpty" class="mb-4">
                <v-col>
                    <v-row class="mt-4 mb-4">

                        <v-col cols="12" md="4">

                            <v-card class="ma-4" elevation="4" rounded>
                                <v-card-title class="text-center">
                                    <h1 class="title mb-0"
                                        v-text="idefixStatusDev[0]['result']?.split('\n')[0]?.split(':')[1]"></h1>
                                </v-card-title>
                                <v-divider></v-divider>
                                <v-card-text class="text-left mx-5 primary--text">

                                    <information-system-date-and-time-row v-if="idefixStatus?.hardware?.dateLuxon"
                                                                          :icon="icons.mdiCalendarRange"
                                                                          :value="idefixStatus?.hardware?.dateLuxon">
                                    </information-system-date-and-time-row>

                                    <information-system-date-and-time-row v-if="idefixStatus?.hardware?.hourLuxon"
                                                                          :icon="'mdi-clock-time-' + wordsZeroToTwelve[idefixStatus?.hardware?.hourWithoutLeadingZeroLuxon]"
                                                                          :value="idefixStatus?.hardware?.hourLuxon">
                                    </information-system-date-and-time-row>

                                    <information-system-date-and-time-row v-if="idefixStatus?.hardware?.timezone"
                                                                          :icon="icons.mdiMapClock"
                                                                          :value="idefixStatus?.hardware?.timezone">
                                    </information-system-date-and-time-row>

                                </v-card-text>
                            </v-card>
                        </v-col>

                        <v-col cols="12" md="4">

                            <v-card class="ma-4" elevation="4" rounded>
                                <v-card-title class="text-center">
                                    <h1 class="title mb-0">{{ $gettext('Device Details') }}</h1>
                                </v-card-title>
                                <v-divider></v-divider>
                                <v-card-text class="text-left">

                                    <row-item-value :item="$gettext('Clock Speed')" value="----"></row-item-value>

                                    <v-row>
                                        <v-col>
                                            <v-row class="subtitle-2">
                                                <v-col v-text="$gettext('RAM Usage')"></v-col>
                                                <v-col class="text-right">{{
                                                        idefixStatus['hardware']['MemAvailable'] + '/' +
                                                        idefixStatus['hardware']['MemTotal']
                                                    }}
                                                </v-col>
                                            </v-row>
                                            <v-progress-linear :title="$gettextInterpolate($gettext('Available RAM: %{ availableRam }, RAM Capacity: %{ totalRam }'), { availableRam: idefixStatus['hardware']['MemAvailable'], totalRam: idefixStatus['hardware']['MemTotal'] })" :value="ramUsagePercentage" height="25"
                                                               striped>
                                                <strong class="white--text" v-text="ramUsagePercentage"></strong>
                                            </v-progress-linear>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col>
                                            <v-row class="subtitle-2">
                                                <v-col v-text="$gettext('Disk Usage')"></v-col>
                                                <v-col class="text-right">{{
                                                        idefixStatus['hardware']['disk occupied'] + '/' +
                                                        idefixStatus['hardware']['disk size']
                                                    }}
                                                </v-col>
                                            </v-row>

                                            <v-progress-linear :title="$gettextInterpolate($gettext('Disk size: %{ diskSize }, Disk occupied: %{ diskOccupied }, Disk free: %{ diskFree }'), { diskSize: idefixStatus['hardware']['disk size'], diskOccupied: idefixStatus['hardware']['disk occupied'], diskFree: idefixStatus['hardware']['disk free'] })" :value="idefixStatus['hardware']['disk used int']"
                                                               height="25"
                                                               striped>
                                                <strong class="white--text">{{
                                                        idefixStatus['hardware']['disk used int'] + '%'
                                                    }}
                                                </strong>
                                            </v-progress-linear>
                                        </v-col>
                                    </v-row>

                                    <row-item-value :item="$gettext('CPU temperature')"
                                                    :value="idefixStatus['hardware']['CPU temperature'] + '°C'"></row-item-value>

                                </v-card-text>
                            </v-card>
                        </v-col>

                        <v-col cols="12" md="4">

                            <v-card class="ma-4" elevation="4" rounded>
                                <v-card-title class="text-center">
                                    <h1 class="title mb-0">{{ $gettext('Applications versions') }}</h1>
                                </v-card-title>
                                <v-divider></v-divider>
                                <v-card-text class="text-left">

                                    <row-item-value :item="$gettext('Shelterbox')" value="----"></row-item-value>
                                    <row-item-value :item="$gettext('Core')" value="----"></row-item-value>

                                    <!--

                                    <v-row>
                                        <v-col>
                                            <div class="subtitle-2">{{ $gettext('Lightphone') }}</div>
                                        </v-col>
                                        <v-col class="text-right">
                                            <div class="subtitle-2">{{ '&#45;&#45;&#45;&#45;' }}</div>
                                        </v-col>
                                    </v-row>

                                    <v-row>
                                        <v-col>
                                            <div class="subtitle-2">{{ $gettext('ShelterAdmin') }}</div>
                                        </v-col>
                                        <v-col class="text-right">
                                            <div class="subtitle-2">{{ '&#45;&#45;&#45;&#45;' }}</div>
                                        </v-col>
                                    </v-row>-->

                                    <v-row>
                                        <v-col class="shrink">
                                            {{ $gettext('OS') }}
                                        </v-col>
                                        <v-col class="grow text-right">
                                            {{ idefixStatusDev[0]['result'].split('\n')[4].split(':')[1] }}
                                            <div v-if="!showMoreOsDetails" class="caption  cursor-pointer"
                                                 @click="toggleShowMoreOsDetails()">{{
                                                    $gettext('More...')
                                                }}
                                            </div>
                                        </v-col>
                                    </v-row>
                                    <v-slide-y-transition>

                                        <v-row v-if="showMoreOsDetails">

                                            <v-col cols="6">
                                                {{ $gettext('Kernel/Architecture') }}
                                            </v-col>
                                            <v-col class="text-right" cols="6">

                                                {{
                                                    idefixStatusDev[0]['result'].split('\n')[5].split(':')[1] + '/' +
                                                    idefixStatusDev[0]['result'].split('\n')[6].split(':')[1].toUpperCase()
                                                }}

                                            </v-col>

                                            <v-col cols="6">
                                                {{ $gettext('UUID/Machine ID') }}
                                            </v-col>
                                            <v-col cols="6">

                                                {{
                                                    idefixStatusDev[0]['result']?.split('\n')[2].split(':')[1]
                                                }}

                                            </v-col>

                                            <v-col cols="6">
                                                {{ $gettext('Boot ID') }}
                                            </v-col>
                                            <v-col cols="6">

                                                {{
                                                    idefixStatusDev[0]['result']?.split('\n')[3].split(':')[1]
                                                }}

                                            </v-col>

                                            <!-- <v-col cols="6">
                                                {{ $gettext('Chassis') }}
                                            </v-col>
                                            <v-col cols="6">

                                                {{
                                                    idefixStatusDev[0]['result']?.split('\n')[2].split(':')[1]
                                                }}

                                                <div @click="toggleShowMoreOsDetails()"
                                                    class="caption text-right cursor-pointer">{{
                                                        $gettext('Less...')
                                                    }}
                                                </div>
                                            </v-col> -->
                                        </v-row>
                                    </v-slide-y-transition>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row class="mb-8">

                        <v-col cols="12" md="6">

                            <v-card class="ma-4" elevation="4" rounded>
                                <v-card-title class="text-center">
                                    <h1 class="title mb-0">{{ $gettext('Services') }}</h1>
                                </v-card-title>
                                <v-divider></v-divider>
                                <v-card-text class="text-left">

                                    <v-row>
                                        <v-col>

                                            <v-sheet class="mx-auto">
                                                <v-slide-group show-arrows>
                                                    <v-slide-item v-for="(service, index) in allServices" :key="index"
                                                                  v-slot="{ active, toggle }">
                                                        <v-btn :active-class="isDark ? 'grey darken-3 white--text' : 'grey lighten-1 white--text font-weight-black'" :icon="((!active && !isViewAllServices))"
                                                               :input-value="active"
                                                               class="mx-2" depressed rounded
                                                               @click="toggle">
                                                            <v-icon
                                                                :class="{ 'mr-2': active || isViewAllServices }"
                                                                :color="getColourOfService(service.status)"
                                                                v-text="!active ? icons.mdiCircle : icons.mdiCircleMedium">
                                                            </v-icon>
                                                            <v-slide-x-transition>
                                                                <div v-if="active || isViewAllServices"
                                                                     v-text="service?.name">
                                                                </div>
                                                            </v-slide-x-transition>
                                                        </v-btn>
                                                    </v-slide-item>
                                                </v-slide-group>
                                            </v-sheet>


                                            <v-row class="subtitle-1 ma-2">
                                                <v-col class="d-flex align-center" cols="12" md="9">

                                                    <v-icon v-if="overAllServiceReport?.red > 0"
                                                            class="red--text mr-2" x-large
                                                            v-text="icons.mdiAlertCircle"></v-icon>

                                                    <!--                                                    <v-icon v-else v-text="icons.mdiCheckCircle"
                                                                                                                class="green&#45;&#45;text mr-2"
                                                                                                        ></v-icon>-->

                                                    <span v-if="overAllServiceReport.red > 1" class="red--text">

                                                        {{
                                                            $gettextInterpolate($gettext('%{ services } services are not running'), {
                                                                services: allServices.filter(s => getColourOfService(s.status) !==
                                                                    'green')?.map(s => s.name)?.join(',').replaceAll(',', ', ')
                                                            })
                                                        }}

                                                    </span>
                                                    <span v-else-if="overAllServiceReport.red > 0"
                                                          class="red--text title">

                                                        {{
                                                            $gettextInterpolate($gettext('%{ service } service is not running'),
                                                                {
                                                                    service: allServices.filter(s => s.status !== 'running')[0]['name']
                                                                })
                                                        }}

                                                    </span>
                                                    <!--
                                                    <span v-else class="green&#45;&#45;text"
                                                        v-text="$gettext('All services are running')">
                                                    </span>
                                                        -->

                                                </v-col>
                                                <v-col class="text-right d-flex align-center justify-end" cols="12"
                                                       md="3">
                                                    <span v-if="!isViewAllServices" class="caption cursor-pointer"
                                                          @click="toggleIsViewAllServices()">
                                                        {{ $gettext('View All Services') }}
                                                    </span>
                                                    <span v-else class="caption cursor-pointer"
                                                          @click="toggleIsViewAllServices()">
                                                        {{ $gettext('Hide All Services') }}
                                                    </span>
                                                </v-col>
                                            </v-row>

                                            <!--                                <v-stepper alt-labels v-model="currentSelectedService">
                                                                                <v-stepper-header>

                                                                                    <template  v-for="(service, index) in allServices">
                                                                                        <v-stepper-step
                                                                                            :key="`${index}-step`"
                                                                                            :complete="currentSelectedService > index"
                                                                                            :step="index"
                                                                                            editable
                                                                                        >
                                                                                            {{ service.name }}
                                                                                        </v-stepper-step>

                                            &lt;!&ndash;                                            <v-divider
                                                                                            v-if="index !== allServices.length"
                                                                                            :key="index"
                                                                                            style="min-width: 100px;"

                                                                                        ></v-divider>&ndash;&gt;
                                                                                    </template>



                                                                                    <v-divider></v-divider>

                                                                                    <v-stepper-step
                                                                                        step="4"
                                                                                        complete
                                                                                    >
                                                                                        Ad style
                                                                                    </v-stepper-step>

                                                                                    <v-divider></v-divider>

                                                                                    <v-stepper-step
                                                                                        :rules="[() => false]"
                                                                                        step="5"
                                                                                    >
                                                                                        Custom channels
                                                                                        <small>Alert message</small>
                                                                                    </v-stepper-step>

                                                                                    <v-divider></v-divider>

                                                                                    <v-stepper-step step="6">
                                                                                        Get code
                                                                                    </v-stepper-step>
                                                                                </v-stepper-header>
                                                                            </v-stepper>-->
                                        </v-col>
                                    </v-row>

                                </v-card-text>
                            </v-card>
                        </v-col>

                        <v-col cols="12" md="3">
                            <v-card class="ma-4" rounded>

                                <v-card-title class="text-center">
                                    <div class="title mb-0">{{ $gettext('Configurations') }}</div>
                                </v-card-title>
                                <v-divider></v-divider>
                                <v-card-text>
                                    <v-list class="subtitle-2">
                                        <v-list-item>
                                            <v-list-item-content class="text-left">
                                                <v-list-item-title>{{ $gettext('DNS') }}</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-btn icon>
                                                    <v-icon v-if="idefixStatus?.config?.unbound === 'OK'" color="green"
                                                            v-text="icons.mdiCheckCircle"></v-icon>
                                                    <v-icon v-else color="red" v-text="icons.mdiCloseCircle"></v-icon>
                                                </v-btn>
                                            </v-list-item-action>
                                        </v-list-item>

                                        <v-list-item>
                                            <v-list-item-content class="text-left">
                                                <v-list-item-title>{{ $gettext('Firewall') }}</v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-btn icon>
                                                    <v-icon v-if="idefixStatus?.config?.nftables === 'OK'" color="green"
                                                            v-text="icons.mdiCheckCircle"></v-icon>
                                                    <v-icon v-else color="red" v-text="icons.mdiCloseCircle"></v-icon>
                                                </v-btn>
                                            </v-list-item-action>
                                        </v-list-item>

                                    </v-list>
                                </v-card-text>
                            </v-card>

                        </v-col>


                        <v-col cols="12" md="3">
                            <v-card class="ma-4" rounded>

                                <v-card-title class="text-center">
                                    <div class="title mb-0">{{ $gettext('Network') }}</div>
                                </v-card-title>
                                <v-divider></v-divider>
                                <v-card-text>
                                    <v-list>

                                        <v-list-item v-for="(n, nIndex) in idefixStatus?.network"
                                                     v-if="n.hasOwnProperty('link')">
                                            <v-list-item-content class="text-left">
                                                <v-list-item-title v-text="nIndex"></v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <!--                                    <v-btn icon>
                                                                                        <v-icon v-text="icons.mdiCheckCircle" color="green"
                                                                                                v-if="n.link === 'UP'"></v-icon>
                                                                                        <v-icon v-text="icons.mdiCloseCircle" color="red" v-else></v-icon>
                                                                                    </v-btn>-->
                                                <span
                                                    :class="{ 'green--text text--darken-4': (n.link === 'UP' && !isDark), 'green--text': (n.link === 'UP' && isDark), 'red--text': n.link !== 'UP' }"
                                                    v-text="(n.ip) + '/' + n.cidr"></span>
                                            </v-list-item-action>
                                        </v-list-item>

                                    </v-list>
                                </v-card-text>
                            </v-card>

                        </v-col>
                        <!--            <v-col cols="12" md="6">

                                        <v-card class="ma-4" rounded elevation="4">
                                            <v-card-title class="text-center">
                                                <h3 class="title mb-0">{{ $gettext('System information') }}</h3>
                                            </v-card-title>
                                            <v-divider></v-divider>
                                            <v-card-text>
                                                <v-simple-table>
                                                    <template v-slot:default>
                                                        &lt;!&ndash;                                <thead>
                                                                                        <tr>
                                                                                            <th class="min-w-200 font-weight-bold">Item</th>
                                                                                            <th class="text-right font-weight-bold">Value</th>
                                                                                        </tr>
                                                                                        </thead>&ndash;&gt;
                                                        <tbody class="">
                                                        <tr>

                                                            <td class="text-left">{{ $gettext('Hostname') }}</td>
                                                            <td class="text-right">{{
                                                                    idefixStatusDev[0]['result'].split('\n')[0].split(':')[1]
                                                                }}
                                                            </td>

                                                        </tr>
                                                        <tr>

                                                            <td class="text-left">{{ $gettext('Kernel/Architecture') }}</td>
                                                            <td class="text-right">{{
                                                                    idefixStatusDev[0]['result'].split('\n')[6].split(':')[1]
                                                                }} /
                                                                {{ idefixStatusDev[0]['result'].split('\n')[7].split(':')[1].toUpperCase() }}
                                                            </td>

                                                        </tr>

                                                        <tr>
                                                            <td class="text-left">{{ $gettext('OS') }}</td>
                                                            <td class="text-right">{{
                                                                    idefixStatusDev[0]['result'].split('\n')[5].split(':')[1]
                                                                }}
                                                            </td>
                                                        </tr>

                                                        <tr>

                                                            <td class="text-left">{{ $gettext('UUID/Machine ID') }}</td>
                                                            <td class="text-right">{{
                                                                    idefixStatusDev[0]['result']?.split('\n')[3].split(':')[1]
                                                                }}
                                                            </td>

                                                        </tr>
                                                        <tr>

                                                            <td class="text-left">{{ $gettext('Up since') }}</td>
                                                            <td class="text-right">{{ idefixStatus?.hardware?.uptime }}</td>

                                                        </tr>

                                                        <tr>

                                                            <td class="text-left">{{ $gettext('Date & Time') }}</td>
                                                            <td class="text-right">
                                                                {{ idefixStatus?.hardware?.date }}
                                                            </td>

                                                        </tr>

                                                        <tr>

                                                            <td class="text-left">{{ $gettext('Timezone') }}</td>
                                                            <td class="text-right">{{ idefixStatus?.hardware?.timezone }}</td>

                                                        </tr>


                                                        </tbody>
                                                    </template>
                                                </v-simple-table>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>-->
                        <!--            <v-col cols="12" md="6">

                                        <v-card class="ma-4" rounded elevation="4">
                                            <v-card-title class="text-center">
                                                <h3 class="title mb-0">{{ $gettext('Usage') }}</h3>
                                            </v-card-title>
                                            <v-divider></v-divider>
                                            <v-card-text>
                                                <v-simple-table>
                                                    <template v-slot:default>
                                                        <tbody class="">
                                                        <tr>

                                                            <td class="text-left">{{ $gettext('Disk Usage') }}</td>
                                                            <td class="text-right min-w-80">
                                                                <v-progress-linear
                                                                    striped
                                                                    height="25"
                                                                    :value="idefixStatus['hardware']['disk used int']"
                                                                    :title="$gettextInterpolate($gettext('Disk size: %{ diskSize }, Disk occupied: %{ diskOccupied }, Disk free: %{ diskFree }'), { diskSize: idefixStatus['hardware']['disk size'], diskOccupied: idefixStatus['hardware']['disk occupied'], diskFree: idefixStatus['hardware']['disk free'] })"
                                                                >
                                                                    <strong class="white&#45;&#45;text">{{
                                                                            idefixStatus['hardware']['disk used int'] + '%'
                                                                        }}
                                                                    </strong>
                                                                </v-progress-linear>
                                                            </td>

                                                        </tr>

                                                        <tr>

                                                            <td class="text-left">{{ $gettext('RAM Usage') }}</td>
                                                            <td class="text-right min-w-80">
                                                                <v-progress-linear
                                                                    height="25"
                                                                    striped
                                                                    :value="ramUsagePercentage"
                                                                    :title="$gettextInterpolate($gettext('Available RAM: %{ availableRam }, Used RAM: %{ usedRam }'), { availableRam: idefixStatus['hardware']['MemAvailable'], usedRam: idefixStatus['hardware']['MemTotal'] })"
                                                                >
                                                                    <strong class="white&#45;&#45;text" v-text="ramUsagePercentage"></strong>
                                                                </v-progress-linear>
                                                            </td>

                                                        </tr>

                                                        <tr>

                                                            <td class="text-left">{{ $gettext('Swap Usage') }}</td>
                                                            <td class="text-right min-w-80">
                                                                <v-progress-linear
                                                                    height="25"
                                                                    striped
                                                                    :value="100"
                                                                >
                                                                    <strong class="white&#45;&#45;text"
                                                                            v-text="idefixStatus['hardware']['Swap']"></strong>
                                                                </v-progress-linear>
                                                            </td>

                                                        </tr>

                                                        </tbody>
                                                    </template>
                                                </v-simple-table>
                                            </v-card-text>
                                        </v-card>

                                        <v-card class="mx-4 mb-4 mt-8" rounded elevation="4">
                                            <v-card-title class="text-center">
                                                <h3 class="title mb-0">{{ $gettext('CPU information') }}</h3>
                                            </v-card-title>
                                            <v-divider></v-divider>
                                            <v-card-text>
                                                <v-simple-table>
                                                    <template v-slot:default>
                                                        <tbody class="">
                                                        <tr>

                                                            <td class="text-left">{{ $gettext('CPU temperature') }}</td>
                                                            <td class="text-right">{{
                                                                    idefixStatus['hardware']['CPU temperature'] + '°C'
                                                                }}
                                                            </td>

                                                        </tr>
                                                        </tbody>
                                                    </template>
                                                </v-simple-table>
                                            </v-card-text>
                                        </v-card>


                                    </v-col>-->

                    </v-row>
                </v-col>
            </v-row>
        </v-fade-transition>


        <!------------------------------------------------
            Services - on/off
        ------------------------------------------------->

        <!--        <v-row>
                    <v-col cols="12" md="6">
                        <v-card class="ma-4" rounded>

                            <v-card-title class="text-center">
                                <h3 class="title mb-0">{{ $gettext('Services') }}</h3>
                            </v-card-title>
                            <v-divider></v-divider>
                            <v-card-text>
                                <v-list>

                                    <information-system-list-row :item="$gettext('DNS')"
                                                                 :green="idefixStatus?.services?.unbound === 'running'"></information-system-list-row>
                                    <information-system-list-row :item="$gettext('DHCP Server')"
                                                                 :green="idefixStatus?.services?.['isc-dhcp-server'] === 'running'"></information-system-list-row>
                                    <information-system-list-row :item="$gettext('Wifi Access')"
                                                                 :green="idefixStatus?.services['hostapd'] === 'running'"></information-system-list-row>
                                    <information-system-list-row :item="$gettext('File Events')"
                                                                 :green="idefixStatus?.services['incron'] === 'running'"></information-system-list-row>
                                    <information-system-list-row :item="$gettext('Database')"
                                                                 :green="idefixStatus?.services['mariadb'] === 'running'"></information-system-list-row>
                                    <information-system-list-row :item="$gettext('HTTP Server')"
                                                                 :green="idefixStatus?.services['nginx'] === 'running'"></information-system-list-row>
                                    <information-system-list-row :item="$gettext('TCP/IP Usage')"
                                                                 :green="idefixStatus?.services['bandwidthd'] === 'running'"></information-system-list-row>
                                    <information-system-list-row :item="$gettext('FTP Server')"
                                                                 :green="idefixStatus?.services['vsftpd'] === 'running'"></information-system-list-row>
                                    <information-system-list-row :item="$gettext('Scheduler')"
                                                                 :green="idefixStatus?.services['cron'] === 'running'"></information-system-list-row>
                                    <information-system-list-row :item="$gettext('Time server')"
                                                                 :green="idefixStatus?.services['ntp'] === 'running'"></information-system-list-row>
                                    <information-system-list-row :item="$gettext('Sys. Console')"
                                                                 :green="idefixStatus?.services['shellinabox'] === 'running'"></information-system-list-row>
                                    <information-system-list-row :item="$gettext('Internet Access')"
                                                                 :green="idefixStatus?.services['ping'] === 'running'"></information-system-list-row>

                                </v-list>
                            </v-card-text>

                        </v-card>

                    </v-col>





                </v-row>-->


        <!--        <v-col v-for="(sd,index) in idefixStatusDev">

                    <v-card elevation="4" class="mx-3">
                        &lt;!&ndash;                   (index + 1) + '.&nbsp;' +&ndash;&gt;
                        <v-card-title v-html="sd.name" class="ml-auto"></v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <v-simple-table>
                                <template v-slot:default>
                                    &lt;!&ndash;                                <thead>
                                                                    <tr>
                                                                        <th class="min-w-200 font-weight-bold">Item</th>
                                                                        <th class="text-right font-weight-bold">Value</th>
                                                                    </tr>
                                                                    </thead>&ndash;&gt;
                                    <tbody class="subtitle-2">
                                    <tr v-for="r in sd.result.split('\n')" :key="index" v-if="shouldShow(r)">

                                        <td class="text-left" v-if="r.includes(':')">{{ r.split(':')[0] }}</td>
                                        <td class="text-right" v-if="r.includes(':')">{{ r.split(':')[1] }}</td>


                                        <td class="text-left" v-if="r.includes('=')">{{ r.split('=')[0] }}</td>
                                        <td class="text-right" v-if="r.includes('=')">{{ r.split('=')[1] }}</td>

                                    </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-card-text>
                    </v-card>


                </v-col>-->


        <!--
                <v-row class="mt-4">
                    <v-col v-for="(s,index) in idefixStatus">
                        <v-card>
                            <v-card-title v-html="index" class="ml-auto"></v-card-title>
                            <v-divider></v-divider>
                            <v-card-text>
                                <v-simple-table v-if="typeof s === 'object'">
                                    <template v-slot:default>
                                        &lt;!&ndash;                                <thead>
                                                                        <tr>
                                                                            <th class="min-w-200 font-weight-bold">Item</th>
                                                                            <th class="text-right font-weight-bold">Value</th>
                                                                        </tr>
                                                                        </thead>&ndash;&gt;
                                        <tbody>
                                        <tr v-for="(r, rIndex) in s" :key="rIndex" v-if="typeof r === 'string'">

                                            <td class="text-left">{{ rIndex }}</td>
                                            <td class="text-right">{{ r }}</td>

                                        </tr>

                                        <v-simple-table v-else-if="typeof r === 'object'">


                                            <tr v-for="(r1, r1Index) in r" :key="r1Index">

                                                <td class="text-left">{{ r1Index }}</td>
                                                <td class="text-right">{{ r1 }}</td>

                                            </tr>

                                        </v-simple-table>

                                        </tbody>
                                    </template>
                                </v-simple-table>
                                <div v-else>
                                    {{ s }}
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
        -->

        <snackbar ref="snackbar"></snackbar>
    </div>
</template>
<script>

import Snackbar from "@/components/Snackbar.vue";
import {useVuetify} from "@/composables/vuetify";
import {computed, reactive, ref, watch} from "vue";
import MixinIcon from "@/mixins/MixinIcon";
import {usePhonesStore} from "@/stores/PhonesStore";
import {storeToRefs} from "pinia";
import {useInformationStore} from "@/stores/InformationStore";
import InformationSystemListRow from "@/components/blocks/information/system/InformationSystemListRow.vue";
import {DateTime} from "luxon";
import InformationSystemDateAndTimeRow
    from "@/components/blocks/information/system/InformationSystemDateAndTimeRow.vue";
import ListingLoading from "@/components/utils/ListingLoading.vue";
import RowItemValue from "@/components/utils/RowItemValue.vue";

export default {
    name: 'System',
    components: {
        RowItemValue,
        ListingLoading,
        InformationSystemDateAndTimeRow,
        InformationSystemListRow,
        Snackbar
    },
    setup(props, context) {

        const vuetify = useVuetify();
        let isDark = computed(() => {
            return vuetify.theme.dark
        })
        const icons = MixinIcon.data().icons

        const informationStore = useInformationStore()

        const {
            idefixStatusDev,
            idefixStatus
        } = storeToRefs(informationStore);

        /*let itemsToHide = [
            'Icon name'
        ]

        const shouldShow = (r) => {

            let show = true
            itemsToHide.forEach((item) => {
                if (r.includes(item)) {
                    show = false
                }
            })
            return show

        }*/

        /*---------------------------------------------
            Os Details Toggle
        ----------------------------------------------*/

        let showMoreOsDetails = ref(false)

        const toggleShowMoreOsDetails = () => showMoreOsDetails.value = !showMoreOsDetails.value

        /*---------------------------------------------
            Services slider
        ----------------------------------------------*/

        let currentSelectedService = ref('');

        let allServices = ref([]);

        let setValueOfAllServices = () => {

            if (idefixStatus.value && idefixStatus.value.hasOwnProperty('services')) {

                allServices.value = [

                    {
                        name: 'DNS',
                        status: idefixStatus?.value?.services?.unbound
                    },/*
                    {
                        name: 'DHCP Server',
                        status: idefixStatus?.value?.services?.['isc-dhcp-server']
                    },*/
                    {
                        name: 'Wifi Access',
                        status: idefixStatus?.value?.services?.['hostapd']
                    },
                    {
                        name: 'File Events',
                        status: idefixStatus?.value?.services?.['incron']
                    },
                    {
                        name: 'Database',
                        status: idefixStatus?.value?.services?.['mariadb']
                    },
                    {
                        name: 'HTTP Server',
                        status: idefixStatus?.value?.services?.['nginx']
                    },
                    {
                        name: 'TCP/IP Usage',
                        status: idefixStatus?.value?.services?.['bandwidthd']
                    },
                    {
                        name: 'FTP Server',
                        status: idefixStatus?.value?.services?.['vsftpd']
                    },
                    {
                        name: 'Scheduler',
                        status: idefixStatus?.value?.services?.['cron']
                    },
                    {
                        name: 'Time server',
                        status: idefixStatus?.value?.services?.['ntp']
                    },
                    {
                        name: 'Sys. Console',
                        status: idefixStatus?.value?.services?.['shellinabox']
                    },
                    {
                        name: 'Internet Access',
                        status: idefixStatus?.value?.services?.['ping']
                    }

                ]

            }


        }
        /**
         * Get the colour of the service
         * @param status
         * @returns {string} This is important because the caller expects it as a string
         */
        let getColourOfService = (status) => {

            let colour = '';
            let s = status?.toLowerCase();

            if (!s) return colour;

            if (['running', 'green'].includes(s)) {
                colour = 'green';
            } else if (['dead', 'red'].includes(s)) {
                colour = 'red'
            } else if (s === 'yellow') {
                colour = 'yellow'
            }

            return colour;

        }


        let overAllServiceReport = reactive({green: 0, red: 0, yellow: 0});

        let calculateOverAllServiceReport = () => {

            allServices.value.forEach((service) => {

                let s = service?.status?.toLowerCase();

                if (s) {

                    switch (getColourOfService(s)) {

                        case 'green': {
                            overAllServiceReport.green++;
                            break;
                        }

                        case 'red': {
                            overAllServiceReport.red++;
                            break;
                        }

                        case 'yellow': {
                            overAllServiceReport.yellow++;
                            break;
                        }

                    }

                }


            });


        }


        /*---------------------------------------------
            User friendly date for the first box
        ----------------------------------------------*/

        let updateDateAndTimeForIdefixStatus = () => {

            if (idefixStatus.value?.hardware?.date && idefixStatus.value?.hardware?.hour) {
                let dateArray = idefixStatus?.value?.hardware?.date?.split('/');
                let hour = idefixStatus?.value?.hardware?.hour;

                // Parse the hour including AM/PM
                let isPM = hour.toLowerCase().includes('pm');
                let hourArray = hour.split(':');
                let hours = parseInt(hourArray[0]);

                // Adjust hours for PM
                if (isPM && hours !== 12) {
                    hours += 12;
                }

                let date = DateTime.local(
                    parseInt(dateArray[2]), // year
                    parseInt(dateArray[1]), // month
                    parseInt(dateArray[0]), // day
                    hours,                 // adjusted hours
                    parseInt(hourArray[1]), // minutes
                    parseInt(hourArray[2])  // seconds
                );

                idefixStatus.value.hardware.dateLuxon = date.toFormat('DDDD');
                idefixStatus.value.hardware.hourLuxon = date.toFormat('tt');
                idefixStatus.value.hardware.hourWithoutLeadingZeroLuxon = date.toFormat('h');
            }

            /*if (idefixStatus.value?.hardware?.date && idefixStatus.value?.hardware?.hour) {

                let dateArray = idefixStatus?.value?.hardware?.date?.split('/');
                let hourArray = idefixStatus?.value?.hardware?.hour?.split(':');

                if (!dateArray || !hourArray) {

                    // FIXME: REMOVE THIS
                    console.log('Error: date and/or hour weren\'t read');

                    if (idefixStatus?.value?.hardware) {
                        idefixStatus.value.hardware.date = 'N/A'
                    }

                } else {

                    let date = DateTime.local(parseInt(dateArray[2]), parseInt(dateArray[1]), parseInt(dateArray[0]), parseInt(hourArray[0]), parseInt(hourArray[1]), parseInt(hourArray[2]));
                    idefixStatus.value.hardware.dateLuxon = date.toFormat('DDDD')
                    idefixStatus.value.hardware.hourLuxon = date.toFormat('tt')
                    idefixStatus.value.hardware.hourWithoutLeadingZeroLuxon = date.toFormat('h')

                }

            }*/

        }

        updateDateAndTimeForIdefixStatus();

        /*---------------------------------------------
            Services
        ----------------------------------------------*/

        let isViewAllServices = ref(false);

        const toggleIsViewAllServices = () => isViewAllServices.value = !isViewAllServices.value

        /*---------------------------------------------
            Ram usage percentage
        ----------------------------------------------*/
        let ramUsagePercentage = ref(0);

        let setRamUsagePercentage = () => {

            if (idefixStatus.value?.hardware?.MemAvailable && idefixStatus.value?.hardware?.MemTotal) {

                ramUsagePercentage.value = Number(
                    (
                        idefixStatus.value?.hardware?.MemAvailable?.replace(' GB', '') /
                        idefixStatus.value?.hardware?.MemTotal?.replace(' GB', '')
                    ) * 100
                ).toLocaleString('en', {minimumFractionDigits: 1, maximumFractionDigits: 1});

            }

        }


        /*---------------------------------------------
            Words zero to twelve for the dynamic clock icon
        ----------------------------------------------*/

        let wordsZeroToTwelve = [
            'zero',
            'one',
            'two',
            'three',
            'four',
            'five',
            'six',
            'seven',
            'eight',
            'nine',
            'ten',
            'eleven',
            'twelve'
        ];

        /*---------------------------------------------
            Timeout
        ----------------------------------------------*/

        let timeout = ref(false);
        setTimeout(() => {
            timeout.value = true;
        }, 5000)

        /*---------------------------------------------
                    Watchers
        ----------------------------------------------*/

        // This is useful when the tab is rendered fully prior visiting
        updateDateAndTimeForIdefixStatus();
        setValueOfAllServices();
        setRamUsagePercentage();
        calculateOverAllServiceReport();

        /**
         * Without this, the expected reactivity is not happening
         * This is useful when the tab is not rendered fully prior visiting
         */
        watch(idefixStatus, () => {
            updateDateAndTimeForIdefixStatus();
            setValueOfAllServices();
            setRamUsagePercentage();
            calculateOverAllServiceReport();
        })

        /*---------------------------------------------
            Computed methods
        ----------------------------------------------*/

        let isIdefixStatusAndIdefixStatusDevEmpty = computed(() => {
            return (typeof idefixStatus.value === 'undefined' && typeof idefixStatusDev.value === 'undefined') || (!idefixStatus.value && !idefixStatusDev.value) || (idefixStatus.value.length === 0 && idefixStatusDev.value.length === 0)
        });

        let idefixStatusIsNotEmpty = computed(() => {
            return (idefixStatus.value && idefixStatusDev.value.length > 0 && idefixStatus.value.hasOwnProperty('hardware'));
        })

        return {
            isDark,
            icons,
            idefixStatusDev,
            idefixStatus,
            // itemsToHide,
            // shouldShow,
            ramUsagePercentage,
            wordsZeroToTwelve,
            showMoreOsDetails,
            toggleShowMoreOsDetails,
            allServices,
            currentSelectedService,
            isViewAllServices,
            toggleIsViewAllServices,
            overAllServiceReport,
            getColourOfService,
            isIdefixStatusAndIdefixStatusDevEmpty,
            idefixStatusIsNotEmpty,
            timeout
        }

    }

}

</script>
<style>
.min-w-200 {
    min-width: 200px;
}

.min-w-80 {
    min-width: 80px;
}

.h-60-vh {
    height: 60vh;
}
</style>
